import { showToast, TOAST_TYPES } from '../components/common/ToastManager';
import { fetchFromChatGPT } from './fetchFromChatGPT';
import { QUESTION_TYPES } from '../components/outputs/interview/utils/questionTypeStyles';

const cleanJsonResponse = (content) => {
  return content.replace(/```json\n?|\n?```/g, '');
};

export const fetchQuickAddsInterviewQuestions = async (formData, isInitial = false, customPrompt = '', selectedType = '') => {
  const context = `
Company: ${formData.companyData?.name}
Role: ${formData.roleData?.jobTitle}
Department: ${formData.roleData?.department}

Key Responsibilities:
${formData.responsibilities
  ?.filter(resp => resp && resp.text)
  .map(resp => `- ${resp.text}`)
  .join('\n')}

Key Outcomes:
${formData.outcomes
  ?.filter(outcome => outcome && outcome.text)
  .map(outcome => `- ${outcome.text}`)
  .join('\n')}
`;

  const typeInstruction = selectedType 
    ? `Generate ${selectedType} questions specifically.` 
    : 'Generate a mix of different question types (warmup, background, technical, behavioral, situational, cultural, and closing questions).';

  const prompt = customPrompt 
    ? `Generate interview questions focusing on: ${customPrompt}. ${typeInstruction}`
    : `Generate diverse interview questions for this role. ${typeInstruction}`;

  try {
    const payload = {
      model: "gpt-3.5-turbo",
      messages: [
        {
          role: "system",
          content: `You are an expert HR professional. Return a JSON array of objects, each with:
- text: The interview question (following strict length guidelines)
- type: One of [${Object.keys(QUESTION_TYPES).join(', ')}]
- description: Array of 3-4 key evaluation points, each focusing on a specific aspect to listen for

Example description format:
[
  "Problem-solving skills in adjusting strategies based on feedback",
  "Creativity in repositioning campaigns for better engagement",
  "Ability to analyze and adapt to market responses"
]

Question Length Guidelines:
${Object.entries(QUESTION_TYPES).map(([type, { label }]) => 
  `- ${label} questions (10-20 words): ${type === selectedType ? 'Focus on this type.' : ''}`
).join('\n')}

Keep questions focused and direct. Each question should:
- Address a single topic or skill
- Be immediately clear to understand
- Avoid compound or multi-part questions
- Use simple, straightforward language
- Match the specified type format and length guidelines

Return the response as a plain JSON array without any markdown formatting.`
        },
        {
          role: "user",
          content: `${context}\n\n${prompt}`
        }
      ],
      temperature: 0.7
    };

    const data = await fetchFromChatGPT(payload);
    const cleanContent = cleanJsonResponse(data.choices[0].message.content);
    const questions = JSON.parse(cleanContent);

    return questions.map(q => ({
      id: `question_${Date.now()}_${Math.random()}`,
      text: q.text,
      type: selectedType || q.type,
      description: q.description
    }));
  } catch (error) {
    console.error('Error fetching quick add questions:', error);
    return [];
  }
}; 